export default __webpack_public_path__ + "static/media/galleryImg2.4faf1461.png";